module.exports = __webpack_public_path__ + "static/media/4cardcolor.0121cf0c.png";